module.exports = __webpack_public_path__ + "img/secondary_2x2_z16.453f0efb.svg";